import React, { useState } from "react";
import TextInput from "../../../components/elements/forms/TextInput";
import { FaRegEnvelope } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import SubmitButton from "../../../components/elements/forms/SubmitButton";
import img from "../../../constant";
import { iForgetPassword, iForgetPasswordError } from "../../../store/types/auth";
import { forgot_password } from "../../../services/api/auth";
import { useAppDispatch } from "../../../store/hooks";
import { get_cookie } from "../../../config/cookie";

const ForgetPassword: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [data, dataSet] = React.useState<iForgetPassword>({
    email: "",
  });
  const [error, errorSet] = React.useState<iForgetPasswordError>({
    email: "",
  });

  const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    dataSet((prev) => ({ ...prev, [name]: value }));
    errorSet((prev) => ({ ...prev, [name]: "" }));
  };

  const onSubmitHandler = async () => {
    let validate: boolean = false;
    if (!data.email) {
      validate = true;
      errorSet((prev) => ({ ...prev, email: "warning" }));
    }
    if (validate) return;
    setLoading(true);
    const success = await forgot_password(data.email, dispatch);
    if (success) {
      navigate("/reset-password");
    }
    setLoading(false);
  };

  const onLoad = React.useCallback(() => {
    if (get_cookie("@serial")) navigate("/reset-password");
  }, [navigate]);

  React.useEffect(() => {
    onLoad();
  }, [onLoad]);

  return (
    <div className="font-abel bg-[#D9ECFF] h-screen">
      <div className="grid md:grid-cols-2 gap-0 md:items-center h-full">
        <div className="col-span-1 h-full hidden md:block">
          <div className="bg-bgLogin bg-cover bg-center h-full">
            <div className="h-full w-full max-w-[588px] mx-auto text-white text-left flex flex-col items-left justify-evenly">
              <Link to={`/`}>
                <img
                  src={img.logoWhite}
                  alt="logo"
                  className="md:w-[100px] w-[65px]"
                />
              </Link>
              <h1 className="text-3xl md:text-[100px] md:leading-[98.2%]">
                AI Recruiter
              </h1>
              <div></div>
            </div>
          </div>
        </div>
        <div className="col-span-1 w-full h-full border-none rounded-lg px-4 md:px-0 py-10 md:py-20">
          <div className="h-[100%] w-full max-w-[650px] bg-[white] py-4 px-4 flex justify-center items-center md:rounded-tr-[20px] md:rounded-br-[20px] md:rounded-[30px] rounded-10">
            <div className="w-[100%] max-w-[500px]">
              <div className="text-center w-full mb-4">
                <div className="flex items-center justify-center mb-5 md:hidden">
                  <Link to={`/home`}>
                    <img
                      src={img.logo}
                      alt="logo"
                      className="md:w-[130px] w-[75px]"
                    />
                  </Link>
                </div>
                <h3 className="md:text-[50px] text-[32px]">Reset Password</h3>
              </div>
              <div>
                <TextInput
                  label="EMAIL ADDRESS"
                  placeholder="Enter Email"
                  name="email"
                  status={error.email}
                  value={data.email}
                  onChange={onChangeHandler}
                  right_icon={
                    <FaRegEnvelope
                      size={20}
                      className="cursor-pointer"
                      color="#667185"
                    />
                  }
                />
                
                <div className="flex justify-between items-center my-4 align-center">
                  <label className="text-[15px]">
                  </label>
                  <Link to="/login" className="text-secondary text-[15px]">
                    Login
                  </Link>
                </div>
                <div className="w-[100%]">
                  <SubmitButton
                    title="Reset Password"
                    onSubmitHandler={onSubmitHandler}
                    loading={loading}
                    className="font-[400] text-white md:hover:bg-[white] md:hover:text-secondary hover:border-primary"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgetPassword;
